var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.97559 7.03467V10.7567",
    stroke: "#F1414D",
    strokeWidth: 1.02,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99974 15.0588C9.33811 15.0588 9.60397 14.7849 9.60397 14.4304C9.60397 14.0759 9.33811 13.802 8.99974 13.802C8.66137 13.802 8.39551 14.0759 8.39551 14.4304C8.39551 14.7849 8.66137 15.0588 8.99974 15.0588Z",
    stroke: "#F1414D",
    strokeWidth: 1.02,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0957 2.15256C9.99898 1.95921 9.83785 1.78197 9.63644 1.66112C9.44308 1.54028 9.21752 1.47583 9 1.47583C8.78248 1.47583 8.55691 1.54028 8.3555 1.66112C8.16214 1.78197 8.01713 1.9431 7.90434 2.15256L1.13695 15.7357C1.04027 15.921 1 16.1304 1 16.3399C1 16.5494 1.07249 16.7588 1.18528 16.928C1.29807 17.1053 1.44308 17.2664 1.62837 17.3631C1.81367 17.4597 2.02314 17.5242 2.2326 17.5242H15.7673C15.9768 17.5242 16.1863 17.4758 16.3716 17.3631C16.5569 17.2664 16.7019 17.1133 16.8147 16.928C16.9275 16.7427 16.9839 16.5494 17 16.3399C17 16.1304 16.9597 15.921 16.8631 15.7357L10.0957 2.15256Z",
    stroke: "#F1414D",
    strokeWidth: 1.02,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.d822aba6b6a05422a1bfc1bb8659073d.svg";
export { ForwardRef as ReactComponent };